import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-section">
          <h3>巨隆液压设备（集团）有限公司</h3>
        </div>
        <div className="footer-section">
          <h4>联系我们</h4>
          <ul className="footer-links">
            <li>电话: 0553-8768888</li>
            <li>邮箱: julongjituan@163.com</li>
            <li>地址: 芜湖市新芜经济开发区工业大道1887号</li>
          </ul>
        </div>
      </div>
      <div className="footer-bottom">
        <p>&copy; 2025 巨隆液压设备（集团）有限公司 版权所有</p>
      </div>
    </footer>
  );
};

export default Footer;
